import { render, staticRenderFns } from "./ordinary.vue?vue&type=template&id=7ad53106&scoped=true&"
import script from "./ordinary.vue?vue&type=script&lang=js&"
export * from "./ordinary.vue?vue&type=script&lang=js&"
import style0 from "./ordinary.vue?vue&type=style&index=0&id=7ad53106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad53106",
  null
  
)

export default component.exports